export default "__VITE_ASSET__97c19773__"